<template>
  <BaseModal
    class="how-to-swap-modal app-container"
    :full-screen="isMobile"
    flush-content
    ui-refresh
    @close-modal-clicked="handleClose">
    <template #body>
      <div class="layout-container d-flex flex-column align-items-center p-md">
        <HowToSwap/>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-center w-100">
        <BaseButton
          text="Go To Case"
          class="w-100"
          @click="handleGoToCase"/>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/global/BaseModal.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import HowToSwap from '@/components/onboarding/HowToSwap.vue'
import useScreenSize from '@shared/composables/screenSize.js'
import { useOnboardingStore } from '@/stores/onboarding.js'
import { useHideIntercomLauncher } from '@shared/composables/intercom.js'
import { useFlyouts } from '@/composables/flyouts.js'
import { onBeforeUnmount, onMounted } from 'vue'
import { useRouter } from 'vue-router'

useHideIntercomLauncher()
const { isMobile } = useScreenSize()
const router = useRouter()
const { openMyCaseFlyout } = useFlyouts()

const onboardingStore = useOnboardingStore()
const {
  trackHowToSwap,
  closeHowToSwapModal
} = onboardingStore

onMounted(() => {
  trackHowToSwap('open')
})

onBeforeUnmount(() => {
  trackHowToSwap('dismiss')
})

function handleClose() {
  trackHowToSwap('click', { button: 'close' })
  closeHowToSwapModal()
}

async function handleGoToCase() {
  trackHowToSwap('click', { button: 'go-to-case' })
  closeHowToSwapModal()
  await router.push({ name: 'closet-sections' })
  openMyCaseFlyout()
}
</script>

<style lang="scss" scoped>
.how-to-swap-modal {
  :deep(.modal-backdrop) {
    --bs-backdrop-opacity: 0.75;
    --bs-backdrop-bg: #{$armor};
  }

  :deep(.modal-content) {
    background-color: $origami;
  }

  :deep(.footer) {
    background: $origami;
    padding: $spacing-md !important;
    border: none;
  }
}
</style>

